import styled from "styled-components";
import { media } from "../../utils/use-media-query";

export const MainHeader = styled.h1<{ titleAlign?: string; children: string | JSX.Element | JSX.Element[] }>`
  text-align: ${(props) => (props.titleAlign ? props.titleAlign : "center")};
  @media (${media.lg}) {
     {
      font-family: Open Sans;
      font-size: 35px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;
      text-transform: uppercase;
    }
  }
  @media (${media.md}) {
     {
      font-family: Open Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;
      text-transform: uppercase;
    }
  }
  @media (${media.sm}) {
     {
      padding: 6rem 1rem;

      font-family: Open Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;
      text-transform: uppercase;
      padding-left: 10px;
    
    }
  }
  @media (${media.xs}) {
     {
      font-family: Open Sans;
      font-size: 2.4rem;
      font-style: normal;
      font-weight: 700;
      line-height: 3.6rem;
      text-transform: uppercase;
    }
  }
`;

export const DownloadAppHeader = styled.h6`
  font-size: 2.4rem;
  line-height: 3.6rem;
  @media (${media.sm}) {
     {
      font-family: Open Sans;
      font-size: 1.5rem;
      width: 60%;
      font-style: normal;

      font-weight: 500;
      line-height: 2rem;
    }
  }
`;

export const VideoFrame = styled.iframe`
  width: 100%;
  height: 76.8rem;
  border: 0;
  @media (${media.sm}) {
     {
      height: 30rem;
    }
  }
`;

export const VideoCover = styled.div<{ bgImage: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 76.8rem;
  cursor: pointer;
  background: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  @media (${media.sm}) {
     {
      height: 30rem;
    }
  }
  &:hover {
    svg {
      transition-duration: 200ms;
      transform: scale(1.5);
    }
  }
`;
